import { Service, service, inject } from './di'
import { FlyerService } from './FlyerService'
import { CouponService } from './CouponService'
import { AnalyticsService } from './AnalyticsService'
import { DisplayType } from '../definitions/ApiDefinitions'
import { itemPopTitle, makeCouponPop, makeItemPop } from '../utils/modal'

@service
export class ModalService extends Service {
    @inject flyerService: FlyerService
    @inject couponService: CouponService
    @inject analytics: AnalyticsService

    async getItemModalData(itemId: number, req: any, res: any, next: any) {
        const item = await this.flyerService.getFlyerItem(itemId)
        if (!item) {
            return next()
        }
        const coupons = await this.couponService.getCouponsForFlyerItem(itemId)
        const flyer = await this.flyerService.getFlyer(item.flyerId)
        res.status = 200
        res.title = itemPopTitle(item, flyer) + ' - Flipp'
        res.description = item.description
        return [item, coupons, flyer]
    }

    makePop(item: any, coupons: any, flyer: any) {
        if (
            item.displayType === DisplayType.COUPONV2 ||
            item.displayType === DisplayType.COUPONV3
        ) {
            if (coupons.length > 0) {
                return makeCouponPop(coupons[0])
            } else {
                return makeItemPop(item, flyer, coupons)
            }
        } else {
            return makeItemPop(item, flyer, coupons)
        }
    }
}
